import {ElementsTree} from "../../../model/ElementsTree";
import {Graph, Node, NodeId, NodeType} from "../../../model/Graph";
import {nodeLabel, nodeService} from "../../playshot/default-service";

export const getNodeByIdOrFQCN = (nodeId: NodeId, fqcn: string, type: NodeType, graph: Graph, elementsTree: ElementsTree): Node | null => {
  const node = graph.getNode(nodeId);

  if(node) {
    return node;
  }

  const service = nodeService(fqcn);

  const matchingNodes = elementsTree.getFilteredElementsByTypeAndLabel(type, nodeLabel(fqcn), service);

  return matchingNodes.first(null);
}
